"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SeatBusiness = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SeatBusiness = function SeatBusiness(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.586 3.568a1.784 1.784 0 100-3.568 1.784 1.784 0 000 3.568zM0 .991l2.233 10.05a5.203 5.203 0 005.08 4.074h3.427v-3.717a1.982 1.982 0 00-1.982-1.982H7.483c-.79 0-1.505-.47-1.82-1.195L3.056 2.187A1.982 1.982 0 001.235.99H0z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.718 7.608l.164.82a3.028 3.028 0 00-.124-.003H7.483a.991.991 0 01-.91-.598l-1.338-3.09a1.846 1.846 0 012.745.184l.56.407a2.652 2.652 0 002.748.228l.886 1.773a4.64 4.64 0 01-3.456.279zM13.642 16l-1.91-3.185v-1.417c0-.888-.39-1.685-1.007-2.23h1.006c.435 0 .839.228 1.063.601l2.973 4.956L13.642 16z",
    fill: "currentColor"
  }));
};

exports.SeatBusiness = SeatBusiness;
var _default = SeatBusiness;
exports.default = _default;